// extracted by mini-css-extract-plugin
export default {"input":"InlineEditor_input__OBniV"};